<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Stock-IN Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Stock-IN</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <b-row class="gutr">
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="stockList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered">
                  <template slot="stockInId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="stockSeries" slot-scope="row1">
                    <span @click="viewStockPage(row1.item)" class="showMoreData">{{row1.item.stockSeries}}</span>
                  </template>

                  <template slot="stockReceivedDate" slot-scope="row12">
                    <span>{{row12.item.stockReceivedDate | moment}}</span>
                  </template>
                  <template slot="loginTime" slot-scope="row116">
                    <span>{{row116.item.loginTime | moment}}</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose"
      ref="addPop"></md-dialog-confirm>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/viewStockIn");
      this.viewStockDetail();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      fields: [
        {
          key: "stockInId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stockSeries",
          label: "Stock-IN No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "poOrderSeries",
          label: "Purchase Order No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stockReceivedDate",
          label: "Stock Received Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stockReceivedBy",
          label: "Stock Received By",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stockCheckedBy",
          label: "Stock Checked By",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "loginTime",
          label: "Creation Date",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: true,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      clientId: "",
      stockList: []
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editStockInId", "");
      this.$sessionsStorage.set("editPOId", "");
      this.$router.push({
        path: "/stockIn"
      });
    },
    JqueryFun() {
      return $(function() {
        return $("#viewSalesBooking").DataTable();
      });
    },

    onClose(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "clientdetail",
          tableIsActive: "clientIsActive",
          tableId: "clientId",
          tableVal: this.clientId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.JqueryFun();
              // this.viewClientDetail();
            }
          })
          .catch(error => {});
      } else {
        // this.viewClientDetail();
      }
    },

    deleteClient(clientID) {
      this.clientId = clientID;
      this.$refs["addPop"].open();
    },

    viewStockPage(item1) {
      this.$sessionsStorage.set("editStockInId", item1.stockInId);
      this.$sessionsStorage.set("editPOId", item1.poOrderId);
      this.$router.push({
        path: "/stockIn"
      });
    },

    viewStockDetail() {
      let payload = {
        view: "view",
        stockInId: ""
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewStockIn.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            if (data.itemArray.length > 0) {
              this.stockList = data.itemArray;
              this.totalRows = data.itemArray.length;
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// viewStockIn.vue?986d5896